<template>
    <div class="section intro" v-if="this.dataLoaded">
        <GridLines />
        <div class="bg-triangle">
            <div class="container">
                <div></div>
            </div>
        </div>
        <div class="bg-image-container" >
            <div class="bg-image"
               data-aos="animation-background-picture"
               data-aos-duration="3000"
            ></div>
        </div>
        <div class="content">
            <div class="container">
                <div class="text-container animated-title" h1 data-aos="new-animation" data-aos-init="aos-init" >
                    <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" v-html="this.page.attributes.title"></h1>
                    <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title subtitle" v-html="this.page.attributes.field_subtitle"></h1>
                    <p class="intro-paragraph" v-html="this.page.attributes.field_description.processed"></p>
                    <a class="read-more" @click="scrollDown()">{{labelReadMore}}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GridLines from "./GridLines.vue"

export default {
  name: 'section-intro',
  components:{
    GridLines
  },
  props: {
      dataPages: {
          type: String
      }
  },
  filters: {
    
  },
  data:()=>{
        return {
            idIntroPage:"d2217035-c711-4613-967a-9f8104ee2cf2",
            page:[],
            dataLoaded:false
        }
  },
  computed:{
      labelReadMore(){
        let label;
        if(this.$route.params.lang == "it"){
            label = "Scopri di più"
        } else {
            label = "Read more"
        }
        return label
      }
  },
methods:{
    scrollDown(){
        let wh = window.innerHeight
        window.scrollTo(0,wh)
    },
    splittedTitle: function (value) {
       return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
    },
    findObjectbyKey(array, key, value){
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null;
    }
},
    mounted(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
            this.dataLoaded = true
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.read-more {
    cursor: pointer;
}
.grid-container {
    z-index: 4;
}

h1:first-child {
    margin-bottom: 0;
}
.subtitle {
    color:#CAC3BB;
    font-size: 3rem;
}
.intro {
      width: 100%;
    height:100vh;
    position: relative;
    padding-top: 0;
    overflow: hidden;
    .content{
        position: relative;
        height: 100vh;
        display: flex;
        align-items: center;
        .text-container {
            position: relative;
            width: 600px;
        }
    }
    .bg-image-container {
        width: 100%;
        height: 100%;
        position: absolute;
        overflow: hidden;
        .bg-image {
        position: absolute;
        background: url("../assets/intro-bg.png") center;
        background-size: cover;
        width: 100%;
        z-index: -1;
        height: 100%;
    }
    }
    .container {
        position: relative;
        z-index: 2;
                display: flex;
    flex-direction: column-reverse;
    }
    .bg-triangle {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        overflow: hidden;
        div div{
            background: #14182E;
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 150vw;
            z-index: 0;
            height: 198vh;
            transform: translate(-60%, 0%) rotate3d(0, 0, 1, 59deg);
            transform-origin: center;
        }
    }
}

h1,p {
    color: #fff;
    width: auto;    }
h1 {
    margin-bottom: 1.5rem;
}

@media (max-width:992px){
    .intro .content .text-container{
        width: 100%;
    }
    .intro .bg-triangle div div {
        transform: translate(-69%, 0%) rotate3d(0, 0, 1, 59deg);
    }

}
@media (max-width:768px){
    .intro .bg-triangle{
        .container{
            max-width: none;
        }
        div div {
            transform: translate(0%, 0%) rotate3d(0, 0, 1, 0deg);
            width: 100%;
            background: linear-gradient(0deg, #14182eb5 80%, #14182e38);
        }
    }

}

@media (max-width:640px){
    .intro .content .text-container{
        width: 100%;
    }
}

</style>
